export default __webpack_public_path__ + "static/media/loading.cce8ad32.svg";